import { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import WorkguildIntro from './video/WorkguildIntro.mp4'; 
import WorkguildIntroCover from './imgs/workguild_video_cover.png';
import listingsImg from './imgs/listings.png';
import applications from './imgs/applications.png';
import tailoredResume from './imgs/tailored_resume.png';

function About() {

  return (
    <main className="about">
      <section style={{display: "flex", flexDirection: 'column', gap: "10px", padding: "20px"}}>
        <h2 style={{textAlign: "center"}}>WELCOME TO WORKGUILD</h2>
        <video style={{width: "90%", maxWidth: "700px", margin: "auto"}} poster={WorkguildIntroCover} controls>
          <source src={WorkguildIntro} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>
      <section className='about'>
        <h2 style={{textAlign: "center"}}>Browse active listings<br/>Not ghost listings</h2>
        <img src={listingsImg} />
      </section>
      <section className='aboutSubheader'>
        <h2>Track, Update, and View résumés all in one place</h2>
        <h4>We'll keep track of the listings to let you know if they are still active</h4>
        <img src={applications} />
      </section>
      <section className='about'>
        <h2>Generate tailored ATS ready resumes based on your employment history</h2>
        <img src={tailoredResume} />
      </section>
      <section style={{display: "flex", flexDirection: "column", padding: "20px", gap: "10px"}}>
        <h2>Accelerate your job hunt!</h2>
        <Link 
          to="/signUp" 
          className="submit" 
          style={{
            gridArea: "aImg", color: "white", width: 'fit-content', 
            padding: "10px", borderRadius: "5px", margin: "auto"}}
          >JOIN THE GUILD!</Link>
      </section>
    </main>
  );
}

export default About;